import { Input, NgModule, OnInit, Directive } from "@angular/core";
import { Dominio } from "src/app/model/dominio-operacao.model";
import { OperacaoCreditoLivre, PagamentoPorTerceiro } from "src/app/model/operacao-credito-livre.model";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaPagamentoPorTerceirosComponent } from "./aba-pagamento-por-terceiros.component";

@NgModule({
    declarations: [AbaPagamentoPorTerceirosComponent],
    imports: [SharedModule],
    exports: [AbaPagamentoPorTerceirosComponent]
})
export class AbaPagamentoPorTerceirosModule implements OnInit {
    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public modoAditivo: Boolean; 
    @Input()
    public emInclusao: Boolean;
    @Input()
    public dadosDominio: Dominio;
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public modoRetificacao: Boolean;

    public identificadorTipoPagamentoEcgTerceiro: number;

    ngOnInit(): void {
        this.identificadorTipoPagamentoEcgTerceiro = this.operacao.identificadorTipoPagamentoEcgTerceiro;
    }

    adicionarGarantia() {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
    }

    removerTipo() {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model; 
        operacaoCreditoLivre.identificadorTipoPagamentoEcgTerceiro = null;
    }

    atribuirTipo(idePagamento: number) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.identificadorTipoPagamentoEcgTerceiro = idePagamento;
    }
}